import SimProgress from './SimProgress';

export default SimProgress;
